var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarksHovering(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.184,
    height: 37.385,
    viewBox: "0 0 27.184 37.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_29_bookmark_page",
    "data-name": "29 bookmark, page",
    transform: "translate(-4 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10576",
    "data-name": "Path 10576",
    d: "M27.786,1H7.4A3.4,3.4,0,0,0,4,4.4V36.679a1.7,1.7,0,0,0,2.549,1.478l11.044-6.32,11.044,6.32a1.7,1.7,0,0,0,2.549-1.478V4.4A3.4,3.4,0,0,0,27.786,1Zm0,32.757L18.442,28.4a1.7,1.7,0,0,0-1.7,0L7.4,33.757V4.4H27.786Z",
    transform: "translate(0)",
    fill: "#B6D6FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksHovering);
export default __webpack_public_path__ + "static/media/bookmarksHovering.aeeecc701e9cd81dab8c1cb3768dbd4e.svg";
export { ForwardRef as ReactComponent };